// src/Helpers/history.js
import { createBrowserHistory } from 'history';

const customHistory = createBrowserHistory();
export default customHistory;
